import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaLock, FaEye, FaEyeSlash, FaArrowRight, FaShieldAlt } from 'react-icons/fa';
import logo from '../../assets/logo.png'; // Using your logo
import './AdminSignIn.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function AdminSignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      let data = null;
      try { data = await res.json(); } catch (e) { /* non-json response */ }
      
      if (res.ok && data && data.success) {
        localStorage.setItem('adminToken', data.token);
        navigate('/admin/add-slider');
      } else if (data && data.message) {
        setError(data.message);
      } else {
        setError('Incorrect email or password');
      }
    } catch (err) {
      setError('Server error. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-auth-container">
      {/* Decorative Background Elements */}
      <div className="admin-auth-shape shape-1"></div>
      <div className="admin-auth-shape shape-2"></div>

      <div className="admin-auth-card">
        
        {/* Header Section with Logo */}
        <div className="admin-auth-header">
          <div className="admin-logo-wrapper">
             <img src={logo} alt="SK College Logo" className="admin-auth-logo" />
          </div>
          <h2 className="admin-auth-title">ADMIN PORTAL</h2>
          <p className="admin-auth-subtitle">SK COLLEGE MANAGEMENT SYSTEM</p>
        </div>

        {/* Form Section */}
        <form className="admin-auth-form" onSubmit={submit}>
          
          {/* Email Input */}
          <div className="admin-input-group">
            <div className="admin-input-icon-box">
              <FaUser />
            </div>
            <input
              className="admin-auth-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Admin Email"
              required
              autoComplete="email"
            />
          </div>

          {/* Password Input */}
          <div className="admin-input-group">
            <div className="admin-input-icon-box">
              <FaLock />
            </div>
            <input
              className="admin-auth-input"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              required
              autoComplete="current-password"
            />
            <button 
              type="button" 
              className="admin-password-toggle"
              onClick={() => setShowPassword(!showPassword)}
              tabIndex="-1"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          {/* Error Message */}
          {error && (
            <div className="admin-auth-error">
              <FaShieldAlt className="error-icon" /> {error}
            </div>
          )}

          {/* Submit Button */}
          <button className="admin-auth-button" type="submit" disabled={loading}>
            {loading ? (
              <span className="loading-spinner"></span>
            ) : (
              <>
                SECURE LOGIN <FaArrowRight className="btn-arrow" />
              </>
            )}
          </button>
        </form>

        <div className="admin-auth-footer">
          <p>&copy; {new Date().getFullYear()} SK College. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
}